export default function createNumberFormatter(locale) {
  return (value, options = {}) => Intl.NumberFormat(locale, options).format(value);
}
